"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@/components/domains/search/search-suggestion/search-suggestion-group");
require("@/components/domains/search/search-suggestion/search-suggestion");
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGlGQUE4RTtBQUM5RSwyRUFBd0UifQ==